<!--
  Implementation

  -in template:
  

  -import:
    import SlottedCardSection from "@/views/layouts/SlottedCardSection.vue";
-->

<template>
  <v-container fluid
               class="pa-0 flex-column align-stretch"
               :class="!valid ? 'errorHighLight' : ''">
    <slot name="header">
      <card-header :title="title ? title : (editModel && editModel.headerTitle ? editModel.headerTitle : 'no title')"
                   :icon="icon ? icon : (editModel ? editModel.enabledIcon : null)"
                   :fontsize="fontsize"
                   :iconsize="iconsize"
                   :headerclass="headerclass"
                   :headertextclass="headertextclass"
                   :nodivider="noheaderdivider"
                   :selectable="!noObjcetsMode && selectable"
                   :editable="!noObjcetsMode && editable"
                   :editMode="editMode"
                   :selectMode="selectMode"
                   :noempty="noempty"
                   :invalidText="invalidText"
                   @Normal="setNormalMode"
                   @Edit="setEditMode"
                   @Select="setSelectMode">

        <template v-slot:title>
          <slot name="headertitle" />
        </template>

        <template v-slot:addedbtns>
          <slot name="headerbtns" />
        </template>

      </card-header>
    </slot>

    <v-form v-model="validfields">
      <slot name="content">
        <selectable-edit-card :editMode="editMode"
                              :selectMode="selectMode"
                              :valid="valid"
                              :limitId="limitId"
                              :selectedId="selectedId"
                              :preselected="preselected"
                              :defaultindex="defaultindex"
                              :editModel="editModel"
                              :newable="newable"
                              :noempty="noempty"
                              :invalidText="invalidText"
                              :perssionDeniedText="perssionDeniedText"
                              @Normal="setNormalMode"
                              @Edit="setEditMode"
                              @Select="setSelectMode"
                              @NoObjects="setNoObjectsMode"
                              @fetch="passFetch">
        </selectable-edit-card>
        <!--
      <EditCard v-else-if="editable"
                :editMode="editMode"
                :preselected="preselected"
                :editModel="editModel"
                @Normal="setNormalMode"
                @Edit="setEditMode">
      </EditCard>
      -->
      </slot>
    </v-form>

  </v-container>
</template>


<script>
import CardHeader from "@/components/Cards/parts/CardHeader.vue";
import SelectableEditCard from "@/components/Cards/Generic/SelectableEditCard.vue";

export default {
  name: "SlottedCardSection",
  props: [
    "title",
    "icon",
    "fontsize",
    "iconsize",
    "headerclass",
    "headertextclass",
    "noheaderdivider",
    "externalEditTrigger",
    "newable",
    "editable",
    "perssionDeniedText",
    "selectable",
    "noempty",
    "limitId",
    "selectedId",
    "defaultindex",
    "preselected",
    "editModel",
  ],
  components: { CardHeader, SelectableEditCard },

  data() {
    return {
      normalModeKey: "normal",
      editModeKey: "edit",
      selectModeKey: "select",
      noobjectsModeKey: "noobjects",
      mode: this.normalModeKey,

      validfields: true,
      validObject: true,
    };
  },

  methods: {
    setEditMode() {
      this.mode = this.editModeKey;
      this.$emit("modeChange", this.mode);
    },
    setNormalMode() {
      this.mode = this.normalModeKey;
      this.$emit("modeChange", this.mode);
    },
    setSelectMode() {
      this.mode = this.selectModeKey;
      this.$emit("modeChange", this.mode);
    },
    setNoObjectsMode() {
      this.mode = this.noobjectsModeKey;
    },
    passFetch(fetchval) {
      this.$emit("fetch", fetchval);
    },
  },

  computed: {
    selectMode() {
      var bool = this.mode === this.selectModeKey;
      this.$emit("selectMode", bool);
      return bool;
    },
    editMode() {
      var bool = this.mode === this.editModeKey;
      this.$emit("editMode", bool);
      return bool;
    },
    noObjcetsMode() {
      var bool = this.mode === this.noobjectsModeKey;
      this.$emit("noObjectsMode", bool);
      return bool;
    },
    valid() {
      //valid if fields are valid, and if required then it also has to exist
      var bool = this.validfields && (this.noempty ? this.validObject : true);
      this.$emit("valid", bool);
      return bool;
    },
    invalidText() {
      if (!this.valid && this.noempty) {
        return this.$t("servicesystem.rules.required_element");
      } else {
        return "";
      }
    },
  },

  watch: {
    noObjcetsMode: function () {
      this.validObject = !this.noObjcetsMode;
    },
    externalEditTrigger: function () {
      this.mode = this.editMode ? this.normalModeKey : this.editModeKey;
    },
  },
};
</script>


<style>
.errorHighLight {
  border: 1px solid red;
  z-index: 5; /** fix to put the container's border above the divider that would otherwise overlap it */
  position: relative;
  min-height: 100%;
}
</style>